import React from 'react';
import styled from 'styled-components';

const SwitchStyled = styled.div`
    background-color: ${props => props.disabled ? 'rgb(115, 115, 115)' : props.isOn ? 'rgb(174, 213, 129)' : 'rgb(190, 190, 190)'};
    border-radius: 8px;
    cursor: pointer;
    height: 16px;
    padding: 0;
    position: relative;
    transition: border-color 400ms cubic-bezier(0.445, 0.05, 0.55, 0.95), background-color 400ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    width: 40px;

    @media screen and (max-width: 850px) {
        order: 2;
    }
`;

const Slider = styled.div`
    background-color: ${props => props.disabled ? 'rgb(203, 203, 203)' : props.isOn ? 'rgb(139, 195, 74)' : 'rgb(255, 255, 255)'};
    box-shadow: 0px 1px 4px #5a5a5a;
    border-radius: 11px;
    cursor: pointer;
    display: block;
    height: 22px;
    position: absolute;
    top: 50%;
    left: ${props => props.isOn ? '90%' : '10%'};
    transform: translate(-50%, -50%);
    transition: left 400ms cubic-bezier(0.39, 0.575, 0.565, 1), background-color 400ms cubic-bezier(0.39, 0.575, 0.565, 1);
    width: 22px;
`;

const Label = styled.div`
    font-weight: normal;
    font-size: 16px;
    position: absolute;
    left: 75px;
    top: 0;
    line-height: 16px;
    white-space: nowrap;
`;

const Switch = (props) => {
    const { isOn, disabled, id, add, remove, addPurpose, removePurpose } = props;

    const handler = () => {
        isOn ? removeHandler(id) : addHandler(id);
    };

    const addHandler = (id) => {
        add(id);
        addPurpose(id);
    };

    const removeHandler = (id) => {
        remove(id);
        removePurpose(id);
    };

    return (
        <SwitchStyled {...props} onClick={disabled ? null : handler}>
            <Slider {...props}></Slider>
            <Label>{isOn ? 'Включено' : 'Изключено'}</Label>
        </SwitchStyled>
    );
}

export default Switch;